<script setup>
import EmergencyLiveClassesTopBanner from '@/components/home/EmergencyLiveClassesTopBanner.vue'
import EmergencyLiveClassesList from '@/components/home/EmergencyLiveClassesList.vue'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import { onMounted, ref } from 'vue'
import AparatVideoPlayer from '@/components/video/AparatVideoPlayer.vue'
import ClPlyrLivePlayer from '@/components/video/ClPlyrLivePlayer.vue'

const liveVideos = ref([])
const onShowingVideo = ref('')
const videoName = ref('')
const videosRepo = RepositoryFactory.get('CourseVideos')
const getLiveVideos = async function () {
  try {
    const { data } = await videosRepo.getLiveVideosFromLanding()
    liveVideos.value = data
  } catch (e) {
    console.log('FETCH LIVE VIDEOS ERROR:', e)
  }
}
const checkVideoType = (videoUrl) => {
  if (videoUrl) {
    if (videoUrl.endsWith('.m3u8')) {
      return 'm3u8'
    } else if (videoUrl.includes('wlproxy')) {
      return 'wlproxy'
    } else {
      return 'default'
    }
  }
}
const changeVideoSource = (source) => {
  onShowingVideo.value = ''
  videoName.value = source.record_video_kavimo
  onShowingVideo.value = source
}
onMounted(async () => {
  await getLiveVideos()
  if (liveVideos.value.length > 0) {
    onShowingVideo.value = liveVideos.value[0]
    videoName.value = onShowingVideo.value.record_video_kavimo
  }
})
</script>

<template>
  <v-row
    v-if="liveVideos.length"
    class="position-relative"
  >
    <v-col :class="[$vuetify.display.mdAndDown ? 'mt-16 mb-5' : 'px-0',]" cols="12" md="12">
      <EmergencyLiveClassesTopBanner :onShowingVideoDescription="onShowingVideo.description"></EmergencyLiveClassesTopBanner>
    </v-col>
    <v-col
      :class="[$vuetify.display.mdAndDown ? 'flex-column' : '']"
      cols="12"
      md="8"
    >
      <v-card rounded="xl" elevation="0">
        <div>
          <AparatVideoPlayer v-if="checkVideoType(videoName) === 'default'" aparatLink="https://www.aparat.com/embed/live/classino_com"></AparatVideoPlayer>
          <ClPlyrLivePlayer v-else :key="videoName" :vod-link="videoName" />
          <div class="mx-5 mt-8">
            <h5 class="font-weight-bold">{{ onShowingVideo.parent_name }}</h5>
            <p>{{ onShowingVideo.name }}</p>
          </div>
        </div>
      </v-card>
    </v-col>
    <EmergencyLiveClassesList
      v-if="liveVideos.length>0"
      @changeVideoSource="changeVideoSource($event)"
      :liveVideoItems="liveVideos"
    ></EmergencyLiveClassesList>
  </v-row>
</template>

<style scoped lang="scss"></style>
